
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'


import { Core } from '../core/core'
import { SeBlockComponent } from './block.component'

@NgModule({
  imports: [
	CommonModule
  ],
  declarations: [
    SeBlockComponent
  ],
  exports: [
    SeBlockComponent
  ]
})
export class SeBlockModule {}

export const SE_BLOCK_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.block`

